// extracted by mini-css-extract-plugin
export default {"spinner-wrapper":"Spinner_spinner-wrapper__4INrY","lds":"Spinner_lds__SzH8H"};